import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialogo-pagos',
  templateUrl: './dialogo-pagos.component.html',
  styleUrls: ['./dialogo-pagos.component.scss']
})
export class DialogoPagosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
